import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { Button } from 'antd';
import { FC, useState } from 'react';

type ModalData = {
	title: string;
	info: string;
};

export const useComplianceInfoModal = () => {
	const [modalData, setModalData] = useState<ModalData>();

	return {
		data: modalData,
		isOpen: Boolean(modalData),
		open: (data: ModalData) => {
			setModalData(data);
		},
		close: () => setModalData(undefined),
	};
};

const ComplianceInfoModal: FC<ReturnType<typeof useComplianceInfoModal>> = (
	props,
) => {
	return (
		<FleetModal
			open={props.isOpen}
			width={700}
			closable={false}
			buttonPosition="center"
			footer={<Button onClick={() => props.close()}>BACK</Button>}
		>
			<FleetTitle>{props.data?.title}</FleetTitle>
			<div style={{ marginTop: 20 }}>
				<div
					dangerouslySetInnerHTML={{
						__html: props.data?.info || '',
					}}
				/>
			</div>
		</FleetModal>
	);
};

export default ComplianceInfoModal;
